import React, { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { MessageThread } from './MessageThread';

const InternalNotesWithTabs = ({
  notes,
  newTitle,
  setNewTitle,
  newDescription,
  setNewDescription,
  handleAddNote,
  deleteNote,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedDescription, setSelectedDescription] = useState('');

  const openModal = (description) => {
    setSelectedDescription(description);
    setShowModal(true);
  };

  return (
    <Box sx={{ width: '100%' }}>     
        <Box sx={{ p: 2 }}>
          <div className="notes-container">
            <div className="note-input-box">
              <div className="note-entry-box">
                <div className="input-group">
                  <label htmlFor="note-title">Title</label>
                  <input
                    id="note-title"
                    type="text"
                    value={newTitle}
                    onChange={(e) => setNewTitle(e.target.value)}
                    placeholder="Title"
                    className="note-title-input"
                    style={{
                      height: '40px',
                      borderRadius: '9px',
                      padding: '8px 12px',
                      border: '1px solid #ccc',
                      fontSize: '14px',
                      resize: 'none',
                      boxSizing: 'border-box',
                    }}
                  />
                </div>

                <div className="input-group">
                  <label htmlFor="note-description">Description</label>
                  <textarea
                    id="note-description"
                    value={newDescription}
                    onChange={(e) => setNewDescription(e.target.value)}
                    placeholder="Take a note... "
                    className="note-title-input"
                    style={{
                      height: '40px',
                      borderRadius: '9px',
                      padding: '8px 12px',
                      border: '1px solid #ccc',
                      fontSize: '14px',
                      resize: 'none',
                      boxSizing: 'border-box',
                    }}
                  />
                </div>

                <div
                  style={{
                    background: '#2d6ec7',
                    color: 'white',
                    padding: '8px',
                    borderRadius: '5px',
                    border: 'none',
                    cursor: 'pointer',
                    marginTop: '4px',
                  }}
                >
                  <button onClick={handleAddNote}>Add</button>
                </div>
              </div>

              <table className="notes-table" style={{ width: '100%', marginTop: '10px' }}>
                <thead>
                  <tr>
                    <th className="internotes-table-th">Note</th>
                    <th className="internotes-table-th">Created By</th>
                    <th className="internotes-table-th">Date</th>
                    <th className="internotes-table-th">Description</th>
                    <th className="internotes-table-th">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {notes.map((note) => (
                    <tr key={note.id}>
                      <td>{note.notes || 'Untitled'}</td>
                      <td>{note?.User?.name || 'N/A'}</td>
                      <td>{new Date(note.createdAt).toLocaleDateString()}</td>
                      <td onClick={() => openModal(note.description)} style={{ cursor: 'pointer' }}>
                        <i className="fa fa-eye"></i> View
                      </td>
                      <td>
                        <button
                          onClick={() => deleteNote(note.id)}
                          title="Delete"
                          style={{ color: '#e12d39', border: 'none', background: 'none', cursor: 'pointer' }}
                        >
                          <i className="bi bi-trash"></i>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {showModal && (
            <div
              style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 1000,
              }}
            >
              <div
                style={{
                  background: '#fff',
                  borderRadius: '10px',
                  padding: '30px 20px',
                  width: '90%',
                  maxWidth: '500px',
                  boxShadow: '0 10px 25px rgba(0,0,0,0.2)',
                  textAlign: 'left',
                  position: 'relative',
                }}
              >
                <h2
                  style={{
                    marginBottom: '15px',
                    fontSize: '20px',
                    fontWeight: '600',
                  }}
                >
                  Description
                </h2>

                <pre
                  style={{
                    maxHeight: '300px',
                    overflowY: 'auto',
                    fontSize: '16px',
                    lineHeight: '1.5',
                    color: '#333',
                    whiteSpace: 'pre-wrap',
                    wordWrap: 'break-word',
                    backgroundColor: '#f9f9f9',
                    padding: '10px',
                    borderRadius: '4px',
                  }}
                >
                  {selectedDescription}
                </pre>

                <div style={{ textAlign: 'end' }}>
                  <button
                    onClick={() => setShowModal(false)}
                    style={{
                      marginTop: '20px',
                      padding: '8px 16px',
                      backgroundColor: '#007bff',
                      color: '#fff',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      textAlign: 'end',
                    }}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          )}
        </Box>

    </Box>
  );
};

export default InternalNotesWithTabs;
